export default "__VITE_ASSET__f2$Tk_ou__"